export const COMMON_EMAIL_VARIABLES = {
  'Client Info': [
    { key: 'client_name', description: 'Client full name' },
    { key: 'client_email', description: 'Client email address' },
    { key: 'client_phone', description: 'Client phone number' },
  ],
  'Tax Information': [
    { key: 'tax_year', description: 'Tax year being filed' },
    { key: 'filing_status', description: 'Filing status' },
    { key: 'ssn_last_4', description: 'Last 4 digits of SSN' },
  ],
  'Appointment Info': [
    { key: 'service_type', description: 'Type of service requested' },
    { key: 'appointment_date', description: 'Scheduled date' },
    { key: 'appointment_time', description: 'Scheduled time' },
    { key: 'duration', description: 'Appointment duration in minutes' },
    { key: 'meeting_link', description: 'Virtual meeting link or location' },
  ],
  'Portal & Links': [
    { key: 'portal_url', description: 'Link to client portal' },
    { key: 'login_url', description: 'Login page URL' },
    { key: 'support_email', description: 'Support contact email' },
  ],
  'General': [
    { key: 'current_date', description: "Today's date" },
    { key: 'admin_name', description: "Admin's name" },
  ],
};

export const getPreviewVariables = () => {
  return {
    client_name: 'John Doe',
    client_email: 'john@example.com',
    client_phone: '(555) 123-4567',
    tax_year: '2024',
    filing_status: 'Single',
    ssn_last_4: '1234',
    service_type: 'Tax Preparation',
    appointment_date: 'March 15, 2025',
    appointment_time: '2:00 PM',
    duration: '60 minutes',
    meeting_link: 'https://tinytaxlady.com/meeting/sample',
    preferred_date: 'March 15, 2025',
    preferred_time: '2:00 PM',
    portal_url: `${window.location.origin}/client-portal`,
    login_url: `${window.location.origin}/auth/login`,
    support_email: 'support@tinytaxlady.com',
    current_date: new Date().toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    }),
    admin_name: 'Tiny Tax Lady',
  };
};

export const replaceVariables = (text: string, variables: Record<string, string>): string => {
  let result = text;
  Object.entries(variables).forEach(([key, value]) => {
    const regex = new RegExp(`{{${key}}}`, 'g');
    result = result.replace(regex, value || '');
  });
  return result;
};

export const getClientVariables = (client: any) => {
  return {
    client_name: client.full_name || '',
    client_email: client.email || '',
    client_phone: client.phone || '',
    tax_year: client.tax_year?.toString() || new Date().getFullYear().toString(),
    filing_status: client.filing_status || '',
    ssn_last_4: client.ssn_last_4 || '',
    portal_url: `${window.location.origin}/client-portal`,
    login_url: `${window.location.origin}/auth/login`,
    support_email: 'support@tinytaxlady.com',
    current_date: new Date().toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    }),
    admin_name: 'Tiny Tax Lady',
  };
};
